var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradableProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.435 19.7624H21.835V21.7624H15.835V15.7624H17.835V18.4924C19.665 17.0224 20.835 14.7824 20.835 12.2624C20.835 8.19238 17.775 4.82238 13.835 4.33238V2.31238C18.885 2.81238 22.835 7.07238 22.835 12.2624C22.835 15.2524 21.515 17.9324 19.435 19.7624ZM4.83496 12.2624C4.83496 9.74238 6.00496 7.49238 7.83496 6.03238V8.76238H9.83496V2.76238H3.83496V4.76238H6.23496C4.15496 6.59238 2.83496 9.27238 2.83496 12.2624C2.83496 17.4524 6.78496 21.7124 11.835 22.2124V20.1924C7.89496 19.7024 4.83496 16.3324 4.83496 12.2624ZM17.075 8.37238L11.415 14.0324L8.58496 11.2024L7.17496 12.6124L11.415 16.8524L18.485 9.78238L17.075 8.37238Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradableProduct);
export default __webpack_public_path__ + "static/media/tradable-product.8469f2137a7086bbab6b4ed0e658ad98.svg";
export { ForwardRef as ReactComponent };